import React from "react";

const SearchTermContext = React.createContext({ searchTerm: "" });

export const SearchTermProvider = SearchTermContext.Provider;
export const useSearchTerm = () => React.useContext(SearchTermContext);
